export function isNonEmptyArray<T>(arr: T[] | undefined): arr is T[] {
    return Array.isArray(arr) && arr.length > 0
}

export function isEmptyArray<T>(arr: T[] | undefined): arr is T[] {
    return Array.isArray(arr) && arr.length === 0
}

/**
 * Returns the index of the found element, in case it's not found 0 is returned
 */
export function findIndexOrFirst<T>(arr: T[], func: (item: T) => boolean): number {
    const foundIndex = arr.findIndex(func)
    return foundIndex === -1 ? 0 : foundIndex 
}